"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
exports.overish = function (defaultReturn) {
    var rules = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        rules[_i - 1] = arguments[_i];
    }
    return function (obj) { return lodash_1.reduce(rules, function (state, ov) {
        var rule = ov.rule, processor = ov.processor;
        var newState = rule && processor && rule(obj) ?
            processor(obj) :
            undefined;
        return newState || state;
    }, defaultReturn); };
};
//# sourceMappingURL=overish.js.map